import { combineReducers } from 'redux';

import api from './api';
import app from './app';
import gCache from './gCache';
import dlareducer from './dlareducer'

import { reducer as auth } from '../../common/auth/index';


export  default combineReducers({
    api,
    app,
    gCache,
    dlareducer,
    auth
});

